{
  "Currency": "Währung",
  "Back to calculation": "Zurück zu Kalkulation",
  "Show required transactions": "Zu erforderlichen Transaktionen",
  "Recalculate": "Neu berechnen",
  "Required transactions": "Erforderliche Transaktionen",
  "Save": "Speichern",
  "Cancel": "Abbrechen"
}
